import { FC } from "react";
import { ItemRendererProps } from "../../../dashboard/item-renderer/types";
import ItemRenderer from "../../../dashboard/item-renderer";
import { Column } from "../../../../components/containers";
import { JustifyContent } from "../../../../components/containers/types";
import { IconAnimation } from "../../../../components/animation";
import { ArrowLeftIcon, TrashIcon } from "../../../../assets/icons";
import { useWidgetStore, useThemeStore } from "../../../../stores";

const EditItemRenderer: FC<ItemRendererProps> = ({ item }) => {
  const theme = useThemeStore((s) => s.theme);
  const mvUpItem = useWidgetStore((s) => s.mvUpItem);
  const mvDownItem = useWidgetStore((s) => s.mvDownItem);
  const rmItem = useWidgetStore((s) => s.rmItem);

  return (
    <div key={item.id} style={{ position: "relative" }}>
      <ItemRenderer edit item={item} />
      <Column
        style={styles.itemRendererController}
        justifyContent={JustifyContent.Center}
        gap={10}
      >
        <IconAnimation
          Icon={ArrowLeftIcon}
          onHoverColor={theme.secondary}
          style={{ cursor: "pointer", transform: "rotate(90deg)" }}
          onClick={() => mvUpItem(item.id)}
        />

        <IconAnimation
          Icon={TrashIcon}
          onHoverColor={theme.alert}
          style={{ cursor: "pointer" }}
          onClick={() => rmItem(item.id)}
        />

        <IconAnimation
          Icon={ArrowLeftIcon}
          onHoverColor={theme.secondary}
          style={{ cursor: "pointer", transform: "rotate(-90deg)" }}
          onClick={() => mvDownItem(item.id)}
        />
      </Column>
    </div>
  );
};

export default EditItemRenderer;

const styles: Record<string, React.CSSProperties> = {
  itemRendererController: {
    position: "absolute",
    top: 0,
    left: -20,
    height: "100%",
  },
};
